import { http } from "@/utils/axios";
import qs from 'qs'

/**
 * @msg: 获取学习结果列表（分页）(点播课)
 */
export function getCourseScore(data) {
    return http({
        url: http.baseUrl('/zkolCourseScore/getPage'),
        method: 'post',
        params: http.params(data)
    })
}

/**
 * @msg: 获取学习结果列表（分页）(班级管理)
 */
export function getPageByWithAlbum(data) {
    return http({
        url: http.baseUrl('/zkolCourseScore/getPageByWithAlbum'),
        method: 'post',
        params: http.params(data)
    })
}

/**
 * @msg: 发送提醒
 */
export function sendMessage(data) {
    return http({
        url: http.baseUrl('zkolCourseScore/sendMessage'),
        method: 'post',
        params: http.params(data),
        data: data,
        paramsSerializer: params => {
            return qs.stringify(params, { indices: false })
        }
    })
}

/**
 * @msg: 获取资源完成情况列表
 */
export function getCourseScoreInfo(data) {
    return http({
        url: http.baseUrl('/zkolCourseScore/getCourseScoreInfo'),
        method: 'get',
        params: http.params(data)
    })
}

/**
 * @msg: 获取综合考核情况
 */
export function getOverallCourseScoreInfo(data) {
    return http({
        url: http.baseUrl('/zkolCourseScore/getOverallCourseScoreInfo'),
        method: 'get',
        params: http.params(data)
    })
}

/**
 * @msg: 保存课程成绩信息
 */
export function saveCourseScore(data) {
    return http({
        url: http.baseUrl('/zkolCourseScore/saveCourseScore'),
        method: 'post',
        params: http.params(data),
        data: data
    })
}

/**
 * @msg: 导入考核分
 */
export function importCourseCheckScore(data) {
    return http({
        url: http.baseUrl('/zkolCourseScore/importCourseCheckScore'),
        method: 'post',
        params: http.params(data),
        data: data
    })
}

/**
 * @msg: 导入考核分(班级管理)
 */
export function importCourseCheckScoreWithAlbum(data) {
    return http({
        url: http.baseUrl('/zkolCourseScore/importCourseCheckScoreWithAlbum '),
        method: 'post',
        params: http.params(data),
        data: data
    })
}

/**
 * @msg: 导入课堂考勤
 */
export function importClassAttendance(data) {
    return http({
        url: http.baseUrl('/zkolCourseScore/importClassAttendance'),
        method: 'post',
        params: http.params(data),
        data: data
    })
}

/**
 * @msg: 导入课堂考勤(班级管理)
 */
export function importClassAttendanceWithAlbum(data) {
    return http({
        url: http.baseUrl('/zkolCourseScore/importClassAttendanceWithAlbum'),
        method: 'post',
        params: http.params(data),
        data: data
    })
}

/**
 * @msg: 修改课堂出勤情况
 */
export function saveClassAttendance(data) {
    return http({
        url: http.baseUrl('zkolCourseScore/saveClassAttendance'),
        method: 'post',
        data: data,
    })
}

/**
 * @msg: 设置课程考核结束时间
 */
export function setCourseAssessEndTime(data) {
    return http({
        url: http.baseUrl('zkolCourseScore/setCourseAssessEndTime'),
        method: 'get',
        params: http.params(data)
    })
}

/**
 * @msg: 班级督学
 */
export function superintendent(data) {
    return http({
        url: http.baseUrl('elAlbum/superintendent'),
        method: 'post',
        params: http.params(data),
        data: data,
    })
}

/**
 * @msg: 根据班级id查询班级名称和班主任名称
 */
export function getElAlbumById(data) {
    return http({
        url: http.baseUrl('elAlbum/getElAlbumById'),
        method: 'get',
        params: http.params(data),
        data: data,
    })
}

/**
 * @msg: 班级课程考勤记录
 */
export function getClassAttendanceWithAlbum(data) {
    return http({
        url: http.baseUrl('zkolCourseScore/getClassAttendanceWithAlbum'),
        method: 'post',
        params: http.params(data),
        data: data,
    })
}


/**
 * @msg: 综合测验试卷预览 /zkfz/elExamsUsers/getStuExam?batchId=c5a6d8800be84e6ca0ef3d110e59745d&courseId=961&uid=19410
 */
export function getStuExam(data) {
    return http({
        url: http.baseUrl('elExamsUsers/getStuExam'),
        method: 'get',
        params: http.params(data),
        data: data,
    })
}